import apiV2Service from 'common/src/modules/api/api-v2.service';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {CreativesManagerAgentToolName} from '../creativesManagerAgent.enums';

const inputSchema = z.object({
  creativeName: z.string(),
});

function getCreativesIdsByNameTool() {
  async function execute({
    input: {creativeName},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    try {
      const {data: creatives} = await apiV2Service.executeGetRequest<
        Array<{id: number; name: string}>
      >(`Creatives/bestMatchByName/${encodeURIComponent(creativeName)}`);

      return toolResult(JSON.stringify(creatives));
    } catch (error) {
      return toolResult(
        JSON.stringify({
          message: 'Error occurred while searching for creatives',
          error: error instanceof Error ? error.message : 'Unknown error',
        }),
      );
    }
  }

  return tool({
    name: CreativesManagerAgentToolName.GetCreativesIdsByName,
    description:
      'Get specific creative id by name. If found multiple creatives with similar names, return all their ids and names',
    displayName: 'Searching creative by name',
    execute,
    inputSchema,
  });
}

export default getCreativesIdsByNameTool;
